<template>
  <div class="company-introduce">
    <VipFixedHeader :scroll-top="scrollTop" @buy="buy"/>
    <HeaderWrap
      @buy="buy"
      @showScope="showScope"
    />


    <div class=" tab-box">
      <div class="tab">
        <div class="tab-bar"
             :class="'tab-bar'+ active"
             :style="{left: (active * 330 )+ 'px'}"/>
        <div class="tab-item"
             :class="{'on': active == index}"
             v-for="(item,index) in [
               {id: 1,title: '商用VIP授权', desc: '适用于个人/组织/企业注册资本≤1000万'},
               {id: 2,title: '企业PLUS授权', desc: '适用于企业注册资本＞1000万国企/大型企业/事业单位'},
               {id: 3,title: '多张套餐购买', desc: '适用于多甲方公司，单张授权更划算'},
             ]"
             :key="item.title"
             @mouseover="active = index"
             @click="toCompanyPlus(item)"
        >
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>

    </div>


    <CompanyVipCardGroup
      @buy="buy"
      @showCertificate="showCertificate"
    />


    <OneStopService/>
    <WelfareBar/>
    <div ref="AuthorizedScope">
      <AuthorizedScope @buy="buy"/>
    </div>
    <UseFlow/>


    <!--    <Privilege />-->
    <!--    <CustomCase/>-->


    <IntroduceCompanyCase class="IntroduceCompanyCase"/>

    <CommonProblem/>

    <CertificateDialog
      ref="CertificateDialog"
      :type="CertificateType"
    />

       <no-ssr>
<!--         <ActCompanyPayDialog/>-->
         <ActTwelveFloat class="ActTwelveFloatWrap"></ActTwelveFloat>
       </no-ssr>
  </div>
</template>

<script>

import {
  HeaderWrap,
  Privilege,
  WelfareBar,
  AuthorizedScope,
  CustomCase,
  CommonProblem,
  CompanyVipCardGroup,
  VipFixedHeader
} from "@/components/introduce/company";
import OneStopService from '@/components/introduce/company/one-stop-service';
import UseFlow from '@/components/introduce/company/use-flow'
import CertificateDialog from '@/components/introduce/company/certificate-dialog'
import {serviceLink} from "@/constant/CONFIG";
import {PAY} from "@/constant/PATH";
import {fnFlowStatistics} from "@/fn";
import {tag} from "@/utils/statUtil";
import ActCompanyPayDialog from '@/components/act/company-pay/dialog'

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';
import IntroduceCompanyCase from "@/components/_components/introduce/company/IntroduceCompanyCase";
import {INTRODUCE_COMPANY_VIP_PLUS,INTRODUCE_MULTIPLE} from "@/constant/_Public/Path"
import {companyStat} from "@/api/stat";
import ActTwelveFloat from "@/components/_Privately/Act/Act202312/ActTwelveFloat.vue";

export default {
  name: "IntroduceCompany",
  layout: 'header-nav',
  components: {
    HeaderWrap,
    Privilege,
    WelfareBar,
    AuthorizedScope,

    CompanyVipCardGroup,
    VipFixedHeader,
    OneStopService,
    CertificateDialog,
    ActCompanyPayDialog,
    UseFlow,
    CustomCase,
    CommonProblem,
    IntroduceCompanyCase,
    ActTwelveFloat

  },
  head() {
    return {
      title: '潮国创意企业VIP会员-正版图片授权,企业商用无压力',
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '企业VIP会员,潮国创意'
        },
        {
          hid: 'description',
          name: 'description',
          content: '潮国创意是目前国内为设计师、创意机构和创作人员寻找高质量、吸睛创意设计资源的素材图片网站。包含各类潮流前沿、高品质正版原创图片素材，chaopx.com 是值得信懒、可商用的潮流设计网站。'
        }
      ]
    }
  },
  data() {
    return {
      serviceLink,
      PAY,
      scrollTop: 0,
      CertificateType: 1,
      active: 0
    }
  },
  async mounted() {
    this.init();
    await companyStat();
  },
  methods: {

    init() {
      fnFlowStatistics.pageFlow('companyVip');
      this.handleScroll()
      window.addEventListener("scroll", this.handleScroll);


    },
    handleScroll() {
      this.scrollTop = this.$refs.AuthorizedScope.getBoundingClientRect().top;
      console.log(this.scrollTop)
    },

    showScope() {
      document.documentElement.scrollTop = 1828
    },

    buy(vipInfo) {
      let link;
      if (vipInfo.ID === -999 || vipInfo.ID === -1) {
        link = this.serviceLink;
      } else {
        tag('充值:企业介绍页:图片')

        link = this.PAY + '/' + vipInfo.ID;
      }
      window.open(link, '_blank');

      this.$emit('buy', vipInfo)
    },

    showCertificate(id) {
      this.CertificateType = id;
      this.$refs.CertificateDialog.show = true;
    },


    toCompanyPlus(item) {
      if (item.id == 2) {
        fnCommon.fnBasic.navigationTo(INTRODUCE_COMPANY_VIP_PLUS)
      }else if (item.id == 3) {
        fnCommon.fnBasic.navigationTo(INTRODUCE_MULTIPLE)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
//
.ActTwelveFloatWrap{
  /deep/.ActTwelveFloat{
    top: auto;
  }
  /deep/.ActTwelveFloat.ON{
    position: fixed;
    right: 50px;
    z-index: 99;
    bottom: 220px;
    top: auto;
  }

}

.company-introduce {
  position: relative;


  .tab-box {
    @include Position(1, 5, 50%, 257px);
    transform: translateX(-50%);

    .tab {
      //width: 656px;
      height: 68px;
      background: #FFFFFF;
      box-shadow: 0px -2px 8px 0px rgba(234, 163, 70, 0.05);
      border-radius: 15px;
      border: 1px solid;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      position: relative;

      .tab-bar {
        //@include BgImage2(319px, 76px, 'introduce/company/CompanyTabActive.png');
        width: 330px;
        background: rgba(16, 122, 255, 1);
        display: flex !important;
        position: absolute;
        left: 0;
        bottom: 0;
        transition: all 0.3s ease;
        height: 82px;
        background: #107AFF;
        z-index: 6;


        &.tab-bar0 {
          border-radius: 14px 0px 0px 14px;

          &:after {
            display: inline-block;
            content: "";
            position: absolute;
            top: 0;
            right: -18px;
            width: 0;
            height: 0;
            border-right: 18px solid transparent;
            border-bottom: 14px solid rgba(16, 122, 255, 0.48);
          }
        }

        &.tab-bar1 {

          &:before {
            display: inline-block;
            content: "";
            position: absolute;
            top: 0;
            left: -18px;
            width: 0;
            height: 0;
            border-left: 18px solid transparent;
            border-bottom: 14px solid rgba(16, 122, 255, 0.48);
          }

          &:after {
            display: inline-block;
            content: "";
            position: absolute;
            top: 0;
            right: -18px;
            width: 0;
            height: 0;
            border-right: 18px solid transparent;
            border-bottom: 14px solid rgba(16, 122, 255, 0.48);
          }
        }

        &.tab-bar2 {
          border-radius: 0px 14px 14px 0px;

          &:before {
            display: inline-block;
            content: "";
            position: absolute;
            top: 0;
            left: -18px;
            width: 0;
            height: 0;
            border-left: 18px solid transparent;
            border-bottom: 14px solid rgba(16, 122, 255, 0.48);
          }
        }
      }

      .tab-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        //justify-content: center;
        //width: 286px;
        width: 330px;
        height: 100%;
        position: relative;
        z-index: 8;
        cursor: pointer;
        color: #666666;

        .title {
          font-size: 16px;
          font-weight: bold;
          color: #666666;
          line-height: 20px;
          margin: 13px 0 6px;
        }

        .desc {
          font-size: 12px;
          line-height: 12px;
          letter-spacing: 1px;
        }

        &.on {
          //background: pink;
          color: #FFFFFF;
          //&.tab-item{
          //background: rgba(16, 122, 255, 1);
          height: 82px;
          position: relative;
          top: -7px;

          .title {
            height: 20px;
            font-size: 20px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 20px;
            margin: 19px 0 14px;
          }

          //}
        }


      }
    }
  }


}

.company-introduce {
  /deep/ .IntroduceCompanyCase {
    height: 856px !important;
    @include BgImage(100%, 856px, 'enterprise/case/card-black.jpg', 1);


    .title {
      //margin: 80px 0 40px;
      //color: rgba(10, 37, 64, 1);
    }

    .btn-group {
      .btn-1 {
        border-color: rgba(255, 208, 172, 1);
        color: rgba(255, 208, 172, 1);
        background: transparent;
      }

      .btn-2 {
        background: linear-gradient(51deg, #F5D9C3 0%, #E8BF97 100%);
        color: rgba(45, 43, 51, 1);
      }
    }

    .btn-group {
      .btn-1 {
        &:hover {
          background: rgba(255, 208, 172, 0.2);
        }
      }

      .btn-2 {
        &:hover {
          background: linear-gradient(51deg, #E8BF97 0%, #F5D9C3 100%);
        }

      }

    }
  }
}

</style>
